module.exports = __webpack_public_path__ + "img/ueli.ce862f6d.jpg";